import { render, staticRenderFns } from "./selection-4.vue?vue&type=template&id=5f510b06&scoped=true&"
import script from "./selection-4.vue?vue&type=script&lang=js&"
export * from "./selection-4.vue?vue&type=script&lang=js&"
import style0 from "./selection-4.vue?vue&type=style&index=0&id=5f510b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f510b06",
  null
  
)

export default component.exports